import Types from "../types";


export function onPersonCenterObjChange(personcenterObj) {
  return { type: Types.PERSONCENTER, personcenterObj: personcenterObj };
}

export function onAuthorizationChange(authorization) {
  return { type: Types.AUTHORIZATION, authorization: authorization };
}

// export function onCurrentUserInfoChange(currentUserInfo) {
//   return { type: Types.CURRENTUSERINFO, currentUserInfo: currentUserInfo };
// }